package com.tfc.care.tfccare.ui

import kotlinx.coroutines.*

open class BaseViewModel {

    private val job = SupervisorJob()

    protected val scope = CoroutineScope(
        Dispatchers.Main.immediate + job
    )

    open fun clear() {
        job.cancel()
    }
}
